import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";
import { PageTitle } from "../components/PageTitle";
import { ProtectedComponent } from "../components/ProtectedComponent";
import { Spinner } from "flowbite-react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Tooltip, IconButton } from "@mui/material";
import { IconContext } from "react-icons";
import useTheme from "../contexts/ThemeContext";

export const FAQ = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(useTheme());

  useEffect(() => {
    axiosInstance
      .get("/v51/faq")
      .then((res) => {
        setQuestions(res.data);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <ProtectedComponent>
      <IconContext.Provider
        value={{
          color: theme == "dark" ? "white" : "black",
          className: "global-class-name",
        }}
      >
        <div className="container mx-auto">
          <PageTitle
            subtitle={"FAQ"}
            title={"Any Questions? Look Here"}
            description={
              "This is a list of the most frequently asked questions. If you have a question that is not listed here, please contact us."
            }
          />

          <div className="mx-10 flex flex-wrap ">
            {loading ? (
              <Spinner />
            ) : (
              questions.map((question, index) => (
                <div className="w-full px-2 lg:w-1/2">
                  <AccordionItem
                    header={question.question}
                    text={question.answear}
                    description={"Added on " + question.added}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </IconContext.Provider>
    </ProtectedComponent>
    // </section>
  );
};

// export default Accordion;

const AccordionItem = ({ header, text, description }) => {
  const [active, setActive] = useState(false);

  const handleToggle = (event) => {
    event.preventDefault();
    setActive(!active);
  };
  return (
    <div className="mb-5 w-full overflow-hidden rounded-3xl bg-white p-5 shadow-lg dark:bg-gray-800 dark:text-white">
      <button
        className={`flex w-full text-left`}
        onClick={(event) => handleToggle(event)}
      >
        <Tooltip title={active ? "retract" : "extend"}>
          <IconButton>
            {active ? <FaChevronUp /> : <FaChevronDown color="" />}
          </IconButton>
        </Tooltip>

        <div className="w-full">
          <h4 className="mt-1 text-lg font-semibold dark:text-white">
            {header}
          </h4>
        </div>
      </button>

      <div
        className={`pl-[62px] duration-200 ease-in-out ${
          active ? "block" : "hidden"
        }`}
      >
        <p className="py-3 text-base leading-relaxed">{text}</p>
        <p className="py-3 text-sm leading-relaxed text-gray-400 dark:text-gray-400">
          {description}
        </p>
      </div>
    </div>
  );
};
